export default {
  loading: 'Chargement des tarifs…',
  default_modal: {
    title: 'Tarif par défaut',
    description:
      "Les tarifs de repli hérités par chaque partenaire sans surcharge propre. Les modifications n'affectent jamais les licences en cours.",
    saved: 'Tarif par défaut enregistré.',
  },
  buttons: {
    edit: 'Modifier',
    cancel: 'Annuler',
    save: 'Enregistrer',
  },
  toasts: {
    load_error: 'Impossible de charger les données tarifaires.',
    save_error: "Impossible d'enregistrer — veuillez réessayer.",
    prices_saved: 'Tarif enregistré.',
    license_created: 'Licence créée.',
    lifecycle: {
      pause: 'Licence suspendue.',
      resume: 'Licence reprise.',
      cancel: 'Licence annulée.',
    },
  },
  price_book: {
    title: 'Tarif',
    read_only_notice:
      'Les tarifs du partenaire remplacent la liste par défaut principale. Les licences en cours conservent leurs prix verrouillés.',
    editing_notice:
      "Modification — les nouveaux tarifs s'appliquent uniquement aux licences créées à partir de maintenant.",
    columns: {
      service: 'Service',
      cost_price: 'Prix brut ({{currency}}/mois, TVA incl.)',
    },
    add_ons: 'Extensions',
    missing_price: '{{name}} est activé mais sans prix — définissez-en un ou désactivez-le.',
    incomplete_tier:
      "{{name}} nécessite à la fois un prix dégressif et le nombre d'établissements actifs à partir duquel il s'applique, ou aucun des deux.",
    invalid_tier:
      "Le prix dégressif de {{name}} doit être inférieur à son prix standard, à partir d'au moins 2 établissements actifs.",
    tier: {
      from: 'Prix dégressif à partir de',
      live_locations: 'établissements actifs',
      counted_one: 'Ce partenaire compte {{count}} établissement sous licence actif pour le tarif dégressif.',
      counted_other: 'Ce partenaire comptabilise {{count}} établissements actifs sous licence pour le tarif dégressif.',
    },
    snapshot_note:
      'Les prix sont verrouillés sur une licence à sa création — la modification de la liste ne change jamais les licences en cours.',
    types: {
      base: 'Base',
      add_on: 'Extension',
    },
  },
  volume_discount: {
    title: 'Remise sur volume',
    read_only_notice:
      "Dès qu'une facture mensuelle atteint le seuil de licences, la remise est déduite de tous les frais de licence du cycle.",
    editing_notice: "Modification — les nouveaux paramètres s'appliquent à partir du prochain cycle de facturation.",
    threshold_label: 'Seuil de licences',
    percent_label: 'Remise',
    invalid: "Saisissez un seuil d'au moins 1 et une remise entre 0 et 100 %.",
    saved: 'Remise sur volume enregistrée.',
    note: "Compte les licences facturées dans le cycle lui-même ; les mois reportés sont exclus. 0 % (valeur par défaut) désactive la remise — sinon elle s'ajouterait au tarif dégressif dans la grille tarifaire.",
  },
  licenses: {
    test_restaurant_unlicensable: "Un restaurant test n'est jamais facturé, il ne peut donc pas avoir de licence.",
    title: 'Licences restaurant',
    select_company: 'Sélectionner un restaurant',
    add_license: 'Ajouter une licence',
    no_companies: "Ce partenaire n'a pas encore de restaurants.",
    no_licenses: 'Aucune licence pour ce restaurant.',
    activated_at: 'Actif depuis',
    next_period_preview: 'Mois suivant (au prorata, avant remise sur volume)',
    statuses: {
      active: 'Actif',
      paused: 'Suspendu',
      canceled: 'Annulé',
    },
    columns: {
      product: 'Service',
      locked_price: 'Prix verrouillé / mois',
      quantity: 'Qté',
      trial_ends: "Gratuit jusqu'au",
    },
    price_tiers: {
      volume: 'Tarif dégressif',
      locked: 'Ancien tarif',
    },
  },
  lifecycle: {
    pause: {
      action: 'Suspendre',
      title: 'Suspendre cette licence ?',
      description:
        'Les jours suspendus ne sont pas facturés. La licence conserve ses prix verrouillés et peut être reprise à tout moment.',
      confirm: 'Suspendre',
    },
    resume: {
      action: 'Reprendre',
      title: 'Reprendre cette licence ?',
      description: "La facturation reprend à partir d'aujourd'hui aux prix verrouillés.",
      confirm: 'Reprendre',
    },
    cancel: {
      action: 'Annuler la licence',
      title: 'Annuler cette licence ?',
      description:
        "Le mois en cours est facturé au prorata jusqu'à aujourd'hui. Cette action est irréversible — une nouvelle licence serait créée aux tarifs actuels.",
      confirm: 'Annuler la licence',
    },
  },
  add_license: {
    title: 'Ajouter une licence',
    description:
      'Sélectionnez les services pour ce restaurant. Les prix sont verrouillés sur la licence à la création.',
    per_month: ' / mois',
    create: 'Créer une licence',
    no_priced_products:
      "Aucun produit n'a encore de prix utilisable pour ce partenaire — définissez d'abord la liste de prix.",
  },
};
